import IconArrowLeft from 'components/IconArrowLeft';
import IconArrowRight from 'components/IconArrowRight';

interface Props {
  currentPage: number;
  perPage: number;
  items: unknown[];
  decrementPage: VoidFunction;
  incrementPage: VoidFunction;
}

function PaginationNav({ currentPage, perPage, items, decrementPage, incrementPage }: Props) {
  function getRangeEnd() {
    const end = currentPage * perPage;
    if (end > items.length) {
      return items.length;
    }
    return end;
  }

  return (
    <div className="flex items-center justify-end gap-8">
      <p className="inline text-sm">
        {currentPage * perPage - (perPage - 1)} - {getRangeEnd()} items of {items.length}
      </p>

      {items.length < perPage ? undefined : (
        <div className="flex items-center">
          <button
            className="cursor:pointer group py-2 px-8 disabled:cursor-not-allowed"
            aria-label="Previous Page"
            disabled={currentPage === 1}
            onClick={() => {
              if (currentPage > 1) {
                decrementPage();
              }
            }}
          >
            <IconArrowLeft className="group-hover:text-blue group-disabled:text-gray" />
          </button>
          <button
            className="cursor:pointer group border-l border-l-gray py-2 px-8 disabled:cursor-not-allowed"
            aria-label="Next Page"
            disabled={getRangeEnd() === items.length}
            onClick={() => {
              if (getRangeEnd() < items.length) {
                incrementPage();
              }
            }}
          >
            <IconArrowRight className="group-hover:text-blue group-disabled:text-gray" />
          </button>
        </div>
      )}
    </div>
  );
}

export default PaginationNav;
